import useSWR from "swr";
import { jsonFetch } from "lib/fetcher";

function getLevel1Geojson(country) {
  return `${process.env.PUBLIC_URL}/maps/${country}/web/level_1.json`;
}

function getLevel2GeoJson(country, idLevel1) {
  return `${process.env.PUBLIC_URL}/maps/${country}/web/level_2/${idLevel1}.json`;
}

function getLevel3GeoJson(country, level1Id, level2Id) {
  return `${process.env.PUBLIC_URL}/maps/${country}/web/level_3/${level1Id}/${level2Id}.json`;
}

function getWorldGeoJson() {
  return `${process.env.PUBLIC_URL}/maps/world/web/level_0.json`;
}

const urls = {
  getWorldGeoJson: getWorldGeoJson,
  getLevel1Geojson: getLevel1Geojson,
  getCountryGeoJson: getLevel1Geojson,
  getLevel2GeoJson: getLevel2GeoJson,
  getStateGeoJson: getLevel2GeoJson,
  getLevel3GeoJson: getLevel3GeoJson,
  getCountyGeoJson: getLevel3GeoJson,

  getWorldChoropleth(date, baseline) {
    return `${process.env.REACT_APP_API_URL}/api/choropleth/world?baseline=${baseline}&date=${date}`;
  },

  getCountryChoropleth(country, date, baseline) {
    return `${process.env.REACT_APP_API_URL}/api/choropleth/country?baseline=${baseline}&date=${date}&country=${country}`;
  },

  getStateChoropleth(country, stateId, date, baseline) {
    return `${process.env.REACT_APP_API_URL}/api/choropleth/state?baseline=${baseline}&date=${date}&country=${country}&state=${stateId}`;
  },

  getCountyChoropleth(country, stateId, countyId, date, baseline) {
    return `${process.env.REACT_APP_API_URL}/api/choropleth/county?baseline=${baseline}&date=${date}&country=${country}&county=${countyId}&state=${stateId}`;

  }
};

export function useWorldChoropleth(shouldFetch, date, baseline) {
  return useSWR(
    shouldFetch ? urls.getWorldChoropleth(date, baseline) : undefined,
    jsonFetch
  );
}

export function useStateChoropleth(
  shouldFetch,
  country,
  stateId,
  date,
  baseline
) {
  return useSWR(
    shouldFetch
      ? urls.getStateChoropleth(country, stateId, date, baseline)
      : undefined,
    jsonFetch
  );
}

export function useCountyChoropleth(
  shouldFetch,
  country,
  stateId,
  countyId,
  date,
  baseline
) {
  return useSWR(
    shouldFetch
      ? urls.getCountyChoropleth(country, stateId, countyId, date, baseline)
      : undefined,
    jsonFetch
  );
}

export function useCountryChoropleth(shouldFetch, country, date, baseline) {
  return useSWR(
    shouldFetch
      ? urls.getCountryChoropleth(country, date, baseline)
      : undefined,
    jsonFetch
  );
}
export { urls };
